<script setup lang="ts">

import { useBreadcrumbs } from "@services/Breadcrumbs";
import { getBackButton } from './useBackButton';

const button = getBackButton();
const breadcrumbs = useBreadcrumbs();

</script>

<template> 

    <div class="absolute top-4 mt-[2px] lg:mt-px z-20 
                aspect-square w-10 3xl:w-12
                flex items-center justify-center
                opacity-0 transition-all duration-150 ease-in" 
         :class="{ 
             'opacity-100 left-2 lg:left-3 3xl:left-4': button.isVisible,
             'pointer-events-none': button.isVisible == false,
         }">
        <div v-if="button.showBackground"
             class="absolute top-0 left-0 w-full h-full rounded-full
                    bg-gray-650 border-2 border-gray-900">
        </div>
        <IconButton name="chevron-left" 
                    class="text-2xl 3xl:text-4xl" 
                    @click="() => breadcrumbs.back()" />
    </div>

</template>